import { computed, defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useDateFormat } from '@/composables/dateFormat';
import { FiscalYearAction, FiscalYearGetter } from '@/store/fiscalYear/fiscalYear.module';
import { FiscalYear } from '@/store/fiscalYear/fiscalYear.model';
import LoadingComponent from '@/components/loading/Loading.vue';

export default defineComponent({
  name: 'FiscalYearTable',
  components: {
    LoadingComponent
  },
  setup: () => {
    const store = useStore();
    const dateFormat = useDateFormat();
    const fiscalYears = computed<FiscalYear[]>(() => store.getters[FiscalYearGetter.ALL]);
    const isLoading = computed(() => store.getters[FiscalYearGetter.STATUS] === 'init' || store.getters[FiscalYearGetter.STATUS] === 'loading');
    const datatable = ref<HTMLTableElement>();
    const dtInstance = ref();

    onMounted(() => {
      Promise.resolve(dtInstance.value?.destroy())
        .then(() => {
          store.dispatch(FiscalYearAction.FETCH)
            .then(() => initialDataTable());
        });
    });

    onUnmounted(() => {
      dtInstance.value?.destroy();
    });

    const initialDataTable = () => {
      const dt = datatable.value as HTMLTableElement;
      if (!$.fn.dataTable.isDataTable(dt)) {
        dtInstance.value = $(dt).DataTable({
          language: {
            emptyTable: 'ไม่พบข้อมูล',
            info: 'แสดง _START_ ถึง _END_ จากจำนวนทั้งหมด _TOTAL_',
            infoEmpty: 'แสดง 0 ถึง 0 จากจำนวนทั้งหมด 0',
            infoFiltered: '(ค้นหาจากจำนวนทั้งหมด _MAX_)',
            lengthMenu: 'แสดงข้อมูล _MENU_',
            paginate: {
              next: 'ถัดไป',
              previous: 'ก่อนหน้า',
              first: 'First',
              last: 'Last'
            },
            search: 'ค้นหา:',
            zeroRecords: 'ไม่พบข้อมูลที่ค้นหา',
          }
        });
      }
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'short');

    const statusHtml = (status: number) =>
      (status !== 0)
        ? (status < 0)
          ? '<span class="text-danger">สิ้นสุดแล้ว</span>'
          : '<span class="text-info">ยังไม่ใช้งาน</span>'
        : '<span class="text-success">ปีงบประมาณปัจจุบัน</span>';

    return {
      isLoading,
      fiscalYears,
      datatable,
      thaiDate,
      statusHtml
    };
  }
});
